import { motion } from 'framer-motion';
import logo from '../assets/logo.png';

export default function Preloader() {
  const containerVariants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 10 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-[#FFFEFA] px-4 text-center">
      <motion.img 
        src={logo} 
        alt="Mangitalia" 
        className="w-28 md:w-36 mb-8"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      />
      
      <motion.div 
        variants={containerVariants}
        initial="hidden"
        animate="show"
        className="flex flex-col gap-2 text-[#7a4a1f] font-medium tracking-wide text-sm md:text-base"
      >
        <motion.span variants={itemVariants}>Prodotti di qualità.</motion.span>
        <motion.span variants={itemVariants}>Produttori di qualità.</motion.span>
        <motion.span variants={itemVariants} className="text-[#c78244] font-bold">Consumatori di qualità.</motion.span>
      </motion.div>
    </div>
  );
}
